import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

import { SiteHeader } from "../../components/header/header";
import { ItemCard } from "../../components/containers/item-card";
import { brands, categories } from "../../_helpers/mock-data";
import { getWishListItems, loadCartItems } from "../../_helpers/cart.methods";
import "../../styles/categories.css";
import { filterData, searchData } from "../../_helpers/filters";
import { CartAddForm } from "../../components/utils/cart-add-form";
import { DarkBg } from "../../components/containers/dark-bg";
import { useProduct } from "../../../services/products/product.context";
import { FooterComponent } from "../../components/footer/footer";
import { InviewAnim } from "../../components/utils/animations";
import { LoadingIndicator } from "../../components/utils/loader";
import { ProductCard } from "../../components/cards/product.card";
import { CostFilter } from "../../../components/utils/cost-filter";

export const Categories = () => {
    const navigateTo = useNavigate();

    const {
        cart,
        someProducts,
        wishList,
        addTowishList,
        loading,
        allProducts,
        pageNum,
        handlePrevPage,
        handleNextPage
    } = useProduct();

    const searchGroup = new URLSearchParams(window.location.search).get('brand');
    const groupName = new URLSearchParams(window.location.search).get('search');
    const categoryName = new URLSearchParams(window.location.search).get('category');


    const [brand, setBrand] = useState(searchGroup || 'All');
    const [category, setCategory] = useState(categoryName || 'All');
    const [filtering, setFiltering] = useState(false);
    const [openCart, setOpenCart] = useState(false);
    const [picked, setPicked] = useState();
    const [searchTerm] = useState(groupName);
    const [products, setProducts] = useState([]);
    const [showCostFilter, setShowCostFilter] = useState(false);
    const [costRange, setCostRange] = useState();

    const getCartElement = (elem) => {
        const cartElem = cart?.find((val) => val._id === elem._id);
        if (cartElem) {
            return cartElem;
        }
        return elem;
    }

    const filterByCost = (min, max) => {
        const resp1 = filterData(brand, category, allProducts);
        const itemList = resp1?.filter((product) => (
            product?.pricing?.original_cost >= min && product?.pricing?.original_cost < max
        ));
        setProducts(itemList);
        setCostRange(`${min} - ${max - 100}`);
    }

    const cancelCostFilter = () => {
        setProducts(someProducts);
        setCostRange();
    }


    useEffect(() => {
        (async () => {

            const resp1 = filterData(brand, category, allProducts);
            setProducts(resp1);
            if (searchTerm) {
                const resp2 = searchData(searchTerm, allProducts);
                setProducts(resp2);
                return;
            }
        })();
    }, [brand, category, searchTerm, pageNum, allProducts]);

    return (
        <div className="app-body">
            <SiteHeader pageTitle={'CATEGORIES'} />
            {openCart && (
                <DarkBg>
                    <CartAddForm
                        itemData={picked}
                        closeCart={() => setOpenCart(false)}
                        opened={openCart}
                        cart={cart}
                    />
                </DarkBg>
            )}
            {loading && <LoadingIndicator />}
            <div className="page-titles">
                <div className="thin-text f-hero">Catalogue</div>
                <div className="slogan-1">
                    {brand !== "All" ? brand : (category !== "All" ? category : 'Tous les produits')}
                </div>
            </div>
            <div className="filter-button-box">
                <button
                    className="filter-button"
                    onClick={() => setFiltering(true)}
                >
                    <img src="/svgs/filter-sort.svg" alt="" className="sm-svg" />
                    <span className="sm-caption">Filtres</span>
                </button>
                <button
                    className="filter-button lng"
                    onClick={() => setShowCostFilter((v) => !v)}
                >
                    <img src="/svgs/filter-sort.svg" alt="" className="sm-svg" />
                    <span className="sm-text">
                        {costRange ? `FCFA ${costRange}` : `Filtrer par coût`}
                    </span>
                </button>
            </div>
            <CostFilter
                shown={showCostFilter}
                handleFilter={(v, w) => filterByCost(v, w)}
                cancelFilter={cancelCostFilter}
            />
            <div className="prod-section">
                <div className={classNames("filter-section", { 'slide-down': filtering })}>
                    <div className="filter-button-box close-box">
                        <button
                            className="filter-button close-button"
                            onClick={() => setFiltering(false)}
                        >
                            <FontAwesomeIcon icon={faClose} />
                        </button>
                    </div>
                    <div className="filter-group">
                        <div className="filter-caption">Categorie</div>
                        <div className="filter-list">
                            <button
                                className={classNames("br-button", { 'sel': category === "All" })}
                                onClick={() => {
                                    setCategory("All");
                                    const res = filterData(brand, "All", products);
                                    setProducts(res);
                                    setFiltering(false);
                                }}
                            >
                                {"Tous"}
                            </button>
                            {categories.map((cat, k) => (
                                <button
                                    className={classNames("br-button", { 'sel': category === cat.name })}
                                    onClick={() => {
                                        setCategory(cat.name);
                                        const res = filterData(brand, cat.name, products);
                                        setProducts(res);
                                        setFiltering(false);
                                    }}
                                    key={k}
                                >
                                    {cat.fr}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="filter-group">
                        <div className="filter-caption">Marques</div>
                        <div className="filter-list">
                            <button
                                className={classNames("br-button", { 'sel': brand === "All" })}
                                onClick={() => {
                                    setBrand("All");
                                    const res = filterData("All", category, products);
                                    setProducts(res);
                                    setFiltering(false);
                                }}

                            >
                                {"Tous"}
                            </button>
                            {brands.map((br) => (
                                <button
                                    className={classNames("br-button", { 'sel': brand === br.name })}
                                    onClick={() => {
                                        setBrand(br.name);
                                        const res = filterData(br.name, category, products);
                                        setProducts(res);
                                        setFiltering(false);
                                    }}
                                >
                                    {br.name}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="filtered-products">
                    <div className="slogan-1">
                        {brand !== "All" ? "Produits de marque" : "Produits"}
                    </div>
                    <div className="thin-text sp-3-st">
                        {(brand !== "All" || category !== "All" || groupName)
                            && products?.length + " produits trouvés"
                        }

                    </div>
                    {products?.length === 0 ?
                        <div className="no-product sp-3-st">
                            <div className="slogan-2">Aucun produit à afficher</div>
                        </div> :
                        <div className="catalog">
                            {products?.map((item, id) => (
                                <InviewAnim
                                    key={id}
                                    inView={'slide-up-after'}
                                    notInView={'slide-up-before'}
                                >
                                    <ProductCard
                                        key={item?._id}
                                        onCartAdd={() => {
                                            const elem = getCartElement(item);
                                            setPicked(elem);
                                            setOpenCart(true);
                                        }}
                                        onLike={() => addTowishList(item)}
                                        item={item}
                                        cart={cart}
                                        wishList={wishList}
                                        onClick={() => navigateTo(`/fr/details`, { state: item })}
                                    />
                                </InviewAnim>
                            ))}
                        </div>
                    }
                    <div className="pagin-buttons">
                        <button
                            className={classNames("pagin-button", { dis: pageNum === 1 })}
                            onClick={handlePrevPage}
                        >
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        <input
                            type="text"
                            value={pageNum}
                            id=""
                            className={classNames("page-num", { dis: pageNum === 1 && products?.length < 20 })}
                        />
                        <button
                            className={classNames("pagin-button", { dis: products?.length < 20 })}
                            onClick={handleNextPage}
                        >
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    </div>
                </div>

            </div>
            <FooterComponent />
        </div>
    )
}